import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";

interface IProps {
    onClick?: () => void;
}

export const ReelModalCloseButton = (props: IProps) => {
    return (
        <Button type="button" variant="none_secondary" onClick={props.onClick} css={buttonStyle}>
            <CloseIcon size="2.4" />
        </Button>
    );
};

const buttonStyle = css`
    position: absolute;
    top: 0;
    right: 0;
    ${flexAbsoluteCenter};
    background-color: #fff;
    border-color: #fff;
    width: ${calculateRemSize(6)};
    height: ${calculateRemSize(6)};
    min-width: auto;
    min-height: auto;
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";

interface IProps {
    onClick?: () => void;
}

export const ReelModalCloseButton = (props: IProps) => {
    return (
        <Button type="button" variant="none_secondary" onClick={props.onClick} css={buttonStyle}>
            <CloseIcon size="2.4" />
        </Button>
    );
};

const buttonStyle = css`
    position: absolute;
    top: 0;
    right: 0;
    ${flexAbsoluteCenter};
    background-color: #fff;
    border-color: #fff;
    width: ${calculateRemSize(6)};
    height: ${calculateRemSize(6)};
    min-width: auto;
    min-height: auto;
`;
